<template>
  <div v-loading="loading" class="addVotingManagement">
    <!-- 投票基本信息 -->
    <div class="votingDetail">
      <h4 class="titleOne">投票详情</h4>
      <div class="item">
        <div class="h5">投票名称:</div>
        <p class="itemIn name">
          {{ voteData.voteName }}
          <i class="prompt">只用于投票管理后台，不显示在下发的投票内容中</i>
        </p>
      </div>
      <div class="item">
        <div class="h5">发布时间:</div>
        <p class="itemIn time">
          {{ startTime() }} 至 {{ endTime() }}
          <i class="status" v-if="voteData.votesState">{{ statusNameMap[voteData.votesState] }}</i>
          <el-button
            v-if="!dateTimeCompShow"
            type="text"
            class="editTime"
            @click="() => changeDateTime()"
          >
            修改截止时间
          </el-button>
        </p>
        <template v-if="dateTimeCompShow">
          <DateTime @dateTimeEmit="dateTimeEmit" />
          <el-button type="primary" @click="() => submitDateTime()">确定</el-button>
          <el-button type="primary" @click="() => cancelDateTime()">取消</el-button>
        </template>
      </div>
      <div class="item">
        <div class="h5">投票人数:</div>
        <p class="itemIn number">{{ voteData.votePersonCount }}人</p>
      </div>
    </div>
    <!-- 导出文档 -->
    <div class="portText">
      <div class="data-Export" @click="summaryDataExport">
        <img src="https://puui.qpic.cn/vupload/0/20200629_b3yr5w1easl/0" class="data-Export-img" />
        <div class="Export">导出文档</div>
      </div>
      <p>查看各个选项中每个参与投票者的具体投票信息，请点击按钮导出数据</p>
    </div>

    <!-- 投票问题详情(单选/多选) -->
    <ul class="questionList">
      <!-- 问题列表 -->
      <template v-for="(item1, index1) in voteData.questionInfoList">
        <!-- 问题选项(单选/多选) -->
        <li v-if="item1.option_type === 1 || item1.option_type === 2" :key="index1" class="item">
          <h6 class="title">
            {{ index1 + 1 }}.{{ item1.questionName }}
            <el-tag>{{ item1.option_type === 1 ? '单选题' : '多选题' }}</el-tag>
          </h6>
          <ul class="itemList">
            <li v-for="(item2, index2) in item1.chooseList" :key="index2" class="questionItem">
              <!-- 选项内容 -->
              <div class="textContent">
                <img v-if="item2.itemImg" class="img" :src="item2.itemImg" />
                <p class="text" :title="item2.itemName">
                  {{ item2.itemName }}
                </p>
              </div>
              <!-- 问题占比 -->
              <div class="percentRate">
                <el-progress
                  :percentage="(item2.voteRate * 100).toFixed(1)"
                  :text-inside="true"
                  :show-text="false"
                  :stroke-width="12"
                />
                <p class="ticketNumber">{{ item2.votePersonCount }}票</p>
                <p class="percentPercent">{{ (item2.voteRate * 100).toFixed(1) }}%</p>
              </div>
            </li>
          </ul>
        </li>
        <!-- 问题选项(简答题) -->
        <li v-if="item1.option_type === 3" :key="index1" class="item">
          <h6 class="title">
            {{ index1 + 1 }}.{{ item1.questionName }}
            <el-tag>简答题</el-tag>
          </h6>
          <ul class="itemList">
            <li class="questionItem">开放问题请导出结果查看</li>
          </ul>
        </li>
      </template>
    </ul>
    <!--动态标签选择-->
    <el-card class="box-card" shadow="never">
      <i class="title">标签:</i>
      <el-form ref="form" :model="form" label-width="96px" class="edit-form">
        <LabelSelect
          :disabled="true"
          :products="form.product"
          :departments="form.department"
          :tags="form.tags"
          :label-amount="10"
          ref="labelSelect"
        ></LabelSelect>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { getChinese } from '@/utils/util.js';
import DateTime from '@/components/date-time';
import { GetVoteByIDApi, UpdVoteEndtimeApi, ExportVoteInfoApi } from '@/api/releaseManagement';
import LabelSelect from '@/components/labelSelect';
const format = 'YYYY-MM-DD HH:mm';
export default {
  name: '',
  components: {
    DateTime,
    LabelSelect,
  },
  props: {
    statusNameMap: {
      type: Object,
      default() {
        return {
          0: '全部',
          1: '编辑中',
          2: '进行中',
          3: '投票截止',
          99: '已删除',
        };
      },
    },
  },
  data() {
    return {
      // 投票数据
      voteData: {
        begin_time: 0,
        voteId: 0,
        voteName: '',
        votePersonCount: 0,
        votesState: 0,
        end_time: 0,
        questionInfoList: [
          {
            chooseList: [
              {
                itemName: '',
                itemImg: '',
                votePersonCount: 0,
              },
            ],
            chooseType: 0,
            questionId: 0,
            questionName: '',
          },
        ],
      },
      getChinese,
      dateTimeCompShow: false, // 日期时间组件是否显示
      expiryTimeTemp: {}, // 暂存日期时间组件数据
      loading: false,
      formData: {
        app_id: null, // 发布账号
        time: null, // 查询时间
      },
      vote_id: '',
      // 下拉框------------------
      // 回显 [{TagId:1, TagType:'xxx'}]
      form: {
        product: [],
        department: [],
        tags: [],
      },
    };
  },
  created() {
    this.vote_id = this.$route.query.date;
    this.getVotesInfo({ vote_id: this.vote_id });
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '', menu_params: {} },
      { menu_name: '投票管理', menu_path: 'voteManagement', menu_params: {} },
      { menu_name: '投票详情', menu_params: { componentName: 'votingDetail' } },
    ];
    this.g_breadcrumb(breadcrumb);
  },
  methods: {
    // 查询投票基本信息
    async getVotesInfo(query) {
      GetVoteByIDApi(query)
        .then((res) => {
          if (res) {
            const { topics } = res.vote_info;
            const { vote_result } = res;
            const { vote_info } = res;
            const voteData = {
              begin_time: vote_info.begin_time * 1000,
              voteId: vote_info.vote_id,
              voteName: vote_info.name,
              votePersonCount: res.total_voter_num,
              votesState: vote_info.status,
              end_time: vote_info.end_time * 1000,
              questionInfoList: [],
            };
            for (let i = 0; i < topics.length; i++) {
              const questionInfoList = {
                chooseList: [],
                chooseType: topics[i].option_type,
                questionId: topics[i].topic_id,
                questionName: topics[i].topic_name,
                option_type: topics[i].option_type, // 选项类型(单选｜多选｜简答题)
              };
              voteData.questionInfoList.push(questionInfoList);
              for (let j = 0; j < topics[i].options.length; j++) {
                const chooseList = {
                  itemName: topics[i].options[j].option_name,
                  itemImg: topics[i].options[j].option_img,
                  votePersonCount: vote_result[i].option_result[j].vote_num,
                  voteRate: vote_result[i].option_result[j].vote_rate,
                };
                voteData.questionInfoList[i].chooseList.push(chooseList);
              }
            }
            this.voteData = voteData;
            this.formatPercentage(voteData);
            // 回显下拉框---
            this.filterSelectTapShow(vote_info);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 过滤下拉框回显格式(前端要的格式)
    filterSelectTapShow(data) {
      const arr1 = data.prod_ids ? data.prod_ids : [];
      const arr2 = data.depart_ids ? data.depart_ids : [];
      const arr3 = data.label_ids ? data.label_ids : [];
      const arr1Temp = [];
      const arr2Temp = [];
      const arr3Temp = [];
      arr1.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 1 });
      });
      arr2.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 2 });
      });
      arr3.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 3 });
      });
      this.form.product = arr1Temp;
      this.form.department = arr2Temp;
      this.form.tags = arr3Temp;
    },
    // 激活修改截止时间事件
    changeDateTime() {
      this.dateTimeCompShow = true;
    },
    // 暂存截止日期数据
    dateTimeEmit(e) {
      this.expiryTimeTemp = e;
    },
    // 提交修改截止时间事件
    async submitDateTime() {
      const temp = this.expiryTimeTemp;
      const { date, hour, minute } = temp;
      if (!date || !hour || !minute) {
        this.$message('请选择日期时间');
        return;
      }
      try {
        this.loading = true;
        let endTime = `${date} ${hour}:${minute}:00`;
        endTime = Math.floor(new Date(endTime).getTime() / 1000);
        const query = {
          end_time: endTime,
          vote_id: this.vote_id,
        };
        UpdVoteEndtimeApi(query)
          .then((res) => {
            if (res) {
              this.$message.success(`修改成功`);
              this.dateTimeCompShow = false;
              this.getVotesInfo({ vote_id: this.vote_id });
              this.$emit('changeDetailEmit', '');
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (error) {
        console.log(error);
        this.$message.error(error);
      }
      this.loading = false;
    },
    // 取消修改截止时间事件
    cancelDateTime() {
      this.dateTimeCompShow = false;
    },
    // 给选项添加百分比
    formatPercentage(datas) {
      const data = datas;
      // 百分比 = 每个选项人数 / 每个问题的总投票人数, 目前每个选项人数有, 但是每个问题的总投票人数需要累加
      for (let i = 0, ilen = data.questionInfoList.length; i < ilen; i++) {
        const iElement = data.questionInfoList[i]; // 每个问题层
        let totalCount = 0;
        for (let j = 0, jlen = iElement.chooseList.length; j < jlen; j++) {
          const jElement = iElement.chooseList[j]; // 每个选项层
          totalCount += jElement.votePersonCount;
        }
        iElement.totalCount = totalCount;
      }
      data.questionInfoList.forEach((e1) => {
        // let totalCount = e1.votePersonCount
        const { totalCount } = e1;
        e1.chooseList.forEach((e2) => {
          const e2s = e2;
          const count = e2s.votePersonCount;
          const percentResult = Math.floor((count / totalCount) * 100);
          isNaN(percentResult) ? (e2s.percentage = 0) : (e2s.percentage = percentResult);
        });
      });
      // 时间戳字符串转数字
      data.end_time = parseInt(data.end_time, 0);
      data.begin_time = parseInt(data.begin_time, 0);
      this.voteData = data;
    },
    // 开始时间换算
    startTime() {
      if (this.voteData.begin_time) {
        return this.$moment(this.voteData.begin_time).format(format);
      }
      return '-';
    },
    // 结束时间换算
    endTime() {
      if (this.voteData.end_time) {
        return this.$moment(this.voteData.end_time).format(format);
      }
      return '-';
    },
    // 导出图表
    async summaryDataExport() {
      const $exportExcelMessage = this.$message({
        message: '开始导出',
        duration: 0,
      });
      try {
        const req = {
          vote_id: this.vote_id,
        };
        ExportVoteInfoApi(req)
          .then((res) => {
            if (res) {
              this.downloadFile(res.content, '投票列表.xlsx');
              res.content ? this.$message.success('导出成功') : this.$message.error('导出失败');
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (error) {
        this.$message.error('导出失败');
      }
      $exportExcelMessage.close();
    },
    downloadFile(url, fileName) {
      const x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    // 隐藏组件  val = 'back'(返回)  'saveOrPublish'(保存或发布)
    closeComp(val) {
      this.$emit('detailVotingShowEmit', val);
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
